import { render, staticRenderFns } from "./my-register.vue?vue&type=template&id=c448b75e&scoped=true&"
import script from "./my-register.vue?vue&type=script&lang=js&"
export * from "./my-register.vue?vue&type=script&lang=js&"
import style0 from "./my-register.vue?vue&type=style&index=0&id=c448b75e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c448b75e",
  null
  
)

export default component.exports